import { ref, onMounted, onUnmounted } from 'vue'

export function useLockScreen() {
  const isLocked = ref(false)
  let lockScreenElement = null

  const createLockScreenElement = () => {
    lockScreenElement = document.createElement('div')
    lockScreenElement.style.position = 'fixed'
    lockScreenElement.style.top = '0'
    lockScreenElement.style.left = '0'
    lockScreenElement.style.width = '100%'
    lockScreenElement.style.height = '100%'
    lockScreenElement.style.backgroundColor = 'black'
    lockScreenElement.style.opacity = '0.9'
    lockScreenElement.style.zIndex = '9999'
    lockScreenElement.style.display = 'flex'
    lockScreenElement.style.justifyContent = 'center'
    lockScreenElement.style.alignItems = 'center'
    lockScreenElement.style.color = 'rgba(255, 255, 255, 0.8)'
    lockScreenElement.style.fontSize = '24px'
    lockScreenElement.innerText = '点击以解锁'
    lockScreenElement.addEventListener('click', toggleLockScreen)
  }

  const toggleLockScreen = () => {
    isLocked.value = !isLocked.value
    if (isLocked.value) {
      document.body.appendChild(lockScreenElement)
    } else {
      document.body.removeChild(lockScreenElement)
    }
  }

  onMounted(() => {
    createLockScreenElement()
  })

  onUnmounted(() => {
    if (lockScreenElement && lockScreenElement.parentNode) {
      lockScreenElement.removeEventListener('click', toggleLockScreen)
      document.body.removeChild(lockScreenElement)
    }
  })

  return {
    isLocked,
    toggleLockScreen
  }
}
